import { SkippedInfos, ExecuteAllEntity } from "./executeAllTasks";
import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import RecurringTaskApp, { RecurringTaskEntity, RecurringTaskAppProps } from "./recurringTask";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { General } from "../../../siteManagement/general";
import { NotificationHelper } from "../../core/util/notificationHelper";
import {SheetEventType} from "../../../siteManagement/sheet";
import React from "react";

export default class skippedTasksGrid extends React.Component<SkippedTasksGridProps, SkippedTasksGridState>{
    private gridOptions = {};
    private translations = {};

    constructor(props: SkippedTasksGridProps) {
        super(props);
        this.gridOptions = this.props.context.skippedTasksGridOptions;
        this._loadGUITranslations();
    }

    private _loadGUITranslations = async () => {
        let result = await Helper.getTranslations(["Standard.Öffnen"]);
        this.translations = result.Data;
        this.setState({});
    }

    handleClickStandardButton = async  (type: ToolBarStandardButtonType, dataItem: SkippedInfos) => {
        if (type === ToolBarStandardButtonType.EDIT) {
            const sheet = General.Sheet.Manager.createSheet();
            
            sheet.bind(SheetEventType.ItemDeleted, ( ) => {
                let changed = this.props.entity.ExecutedAllResult.SkippedTasksInfos.filter((v) => v.TaskId != dataItem.TaskId);
                this.onChange(changed);
            });
            
            let result = await Promise.all([HTTPService.get<JsonResultClass<RecurringTaskEntity>>("RecurringTask/Init?id=" + dataItem.TaskId), Helper.getMetaData("recurringTask")]);

            if (result[0].Code === 0) {
                sheet.show(() => {
                    let title = result[0].Data.Title;
                    const props: RecurringTaskAppProps = {
                        context: {
                            key1: "entity.Id",
                            keyVal1: dataItem.TaskId,
                            contextType: "recurringTask",
                            workPackageGridOptions: null,
                            machineGridOptions: null,
                            standAlone: false
                        },
                        title: "",
                        entity: result[0].Data,
                        metadata: result[1],
                        dataSources: {},
                        isWindow: false
                    };
                    sheet.setTitle(title);
                    sheet.mountContent(RecurringTaskApp, props);
                });
            }
            else {
                NotificationHelper.showErrorMessage(result[0].Message);
            }
        }
    }

    private selectionChange = (dataItem: SkippedInfos) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({
                canWriteEntity: true
            });
        }
    }
    
    private onChange = (data: SkippedInfos[]) => {
        this.props.onChange({model: "entity.ExecutedAllResult.SkippedTasksInfos"}, data)
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];

        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Öffnen"), enabled: true })
        return (<Grid data={this.props.entity.ExecutedAllResult.SkippedTasksInfos}
            standardButtons={standardButtons}
            onClickStandardButton={this.handleClickStandardButton}
            onSelectionChanged={this.selectionChange}
            id="skippedTasksGrid"
            options={this.gridOptions}></Grid>);
    }
}

interface SkippedTasksGridState {
    canWriteEntity: boolean
}
interface SkippedTasksGridProps {
    entity: ExecuteAllEntity;
    context: {
        skippedTasksGridOptions?: {}
    };
    field: any;
    onChange: (field, value) => void;
}